/* eslint-disable new-cap */
import { css } from "styled-components";
import {
  Body1Styles,
  H3Styles,
  LinkStyles,
  TextAlignment,
  Variant
} from "@arcteryx/components-typography";

export const HelpStyles = () => css`
  #content .accordion,
  .accordion {
    position: relative;
    background: #fff;
  }

  @media screen and (min-width: 930px) {
    #content .accordion,
    .accordion {
      width: 98%;
    }
    .URBAN.PRODUCT #content .accordion,
    .URBAN.PRODUCT .accordion {
      width: 100%;
    }
  }

  #content .accordion h3,
  .accordion h3 {
    font-size: 16px;
    line-height: 1.1em;
    margin: 0 0 0.3em 0;
  }

  .URBAN.PRODUCT #content .accordion h3,
  .URBAN.PRODUCT .accordion h3 {
    text-transform: uppercase;
  }

  .URBAN.PRODUCT #content .accordion:last-of-type,
  .URBAN.PRODUCT .accordion:last-of-type {
    border-bottom: 1px solid #ccc;
  }

  #content .accordion__title,
  .accordion__title {
    position: relative;
    cursor: pointer;
    padding: 15px 0 0 5px;
    z-index: 1;
  }

  @media screen and (min-width: 930px) {
    #content .accordion__title,
    .accordion__title {
      padding: 15px 0 0 0;
    }
  }

  #content .accordion__title h2,
  .accordion__title h2 {
    font-size: 16px;
    line-height: 1.25em;
    margin: 10px 0;
    width: 90%;
    -webkit-transition: 0.2s ease all;
    transition: 0.2s ease all;
  }

  .accordion--open #content .accordion__title h2,
  .accordion--open .accordion__title h2 {
    font-size: 18px;
  }

  #content .accordion__title p,
  .accordion__title p {
    width: 90%;
    line-height: initial;
    margin: 0 !important;
  }

  .accordion--open #content .accordion__title p,
  .accordion--open .accordion__title p {
    font-family: "urw-din-condensed", arial, sans-serif;
    font-size: 16px !important;
    -webkit-transition: 0.2s ease all;
    transition: 0.2s ease all;
  }

  .URBAN.PRODUCT #content .accordion__title,
  .URBAN.PRODUCT .accordion__title {
    border-top: 1px solid #ccc;
    padding: 10px 0;
  }

  .URBAN.PRODUCT .accordion__bottom-line {
    display: none;
  }

  #content .accordion__content,
  .accordion__content {
    padding: 20px 0 30px 5px;
  }

  @media screen and (min-width: 930px) {
    #content .accordion__content,
    .accordion__content {
      padding: 20px 0 30px 0;
    }
  }

  #content .accordion__content .widget h1,
  #content .accordion__content .widget h2,
  .accordion__content .widget h1,
  .accordion__content .widget h2 {
    display: none;
  }

  #content .accordion__content .video-widget,
  .accordion__content .video-widget {
    z-index: 2;
  }

  #content .accordion__content ul,
  .accordion__content ul {
    padding: 0 15px 0 5px;
  }

  #content .accordion__content ul li,
  .accordion__content ul li {
    list-style: disc outside none;
    position: relative;
    left: 15px;
  }

  #content .accordion__content .key-features-widget.gallery,
  .accordion__content .key-features-widget.gallery {
    width: 100%;
  }

  #content .accordion__content a,
  .accordion__content a {
    text-decoration: underline;
  }

  .URBAN.PRODUCT #content .accordion__content ul li,
  .URBAN.PRODUCT .accordion__content ul li {
    list-style: none;
    left: -5px;
    padding: 15px 0 0 0;
    max-width: 350px;
  }

  #content .accordion__toggle,
  .accordion__toggle {
    border: 0;
    outline: none;
    background: transparent;
    position: absolute;
    right: 0;
    bottom: -5px;
    cursor: pointer;
  }

  #content .accordion__toggle span,
  .accordion__toggle span {
    color: transparent !important;
  }

  .accordion--close #content .accordion__toggle span:after,
  .accordion--close .accordion__toggle span:after {
    content: "+";
    color: #000;
    font-size: 22px;
    display: inline-block;
    -webkit-transition: 0.2s ease;
    transition: 0.2s ease;
  }

  .accordion--open #content .accordion__toggle,
  .accordion--open .accordion__toggle {
    right: -4px;
    bottom: -6px;
  }

  .accordion--open #content .accordion__toggle span:after,
  .accordion--open .accordion__toggle span:after {
    content: "+";
    color: #000;
    font-size: 28px;
    display: inline-block;
    -webkit-transition: 0.2s ease;
    transition: 0.2s ease;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  .URBAN.PRODUCT .accordion--open #content .accordion__toggle,
  .URBAN.PRODUCT .accordion--open .accordion__toggle {
    bottom: 16px;
  }

  .URBAN.PRODUCT #content .accordion__toggle,
  .URBAN.PRODUCT .accordion__toggle {
    bottom: 15px;
  }

  .accordion__bottom-line {
    border-bottom: 1px solid #ccc;
    margin-bottom: 5px;
  }

  #product-full-features .accordion__content__grid--two-col {
    min-height: 480px;
  }

  @media screen and (min-width: 930px) {
    #product-full-features .accordion__content__grid--two-col {
      min-height: 500px;
    }
  }

  @media screen and (min-width: 930px) {
    #product-full-features .accordion__content__grid--two-col,
    #product-materials-care .accordion__content__grid--two-col {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
    }
  }

  .accordion__content__grid--two-col > div {
    display: inline-block;
    margin: 0 10px 20px 0;
    width: 100%;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 48%;
    flex: 1 1 48%;
  }

  .URBAN.PRODUCT .accordion__content__grid--two-col {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }

  .URBAN.PRODUCT .accordion__content__grid--two-col > div {
    display: inline-block;
    margin: 0 5px 20px 0;
    width: 100%;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 48%;
    flex: 1 1 48%;
  }

  @media screen and (min-width: 1065px) {
    .URBAN.PRODUCT .accordion__content__grid--two-col {
      min-height: 200px;
      -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
    }
    .URBAN.PRODUCT .accordion__content__grid--two-col > div {
      display: inline-block;
      margin: 0 10px 20px 0;
      width: 100%;
      -webkit-box-flex: 1;
      -ms-flex: 1 1 15%;
      flex: 1 1 15%;
    }
  }

  body {
    overflow: hidden;
  }

  .customer-form {
    border: 0 !important;
  }

  #content.customer-support-centre,
  #content .account__help-content,
  #content.help {
    width: 88%;
    max-width: 1430px;
    margin: 0 auto;
  }

  @media screen and (max-width: 1064px) {
    #content.customer-support-centre,
    #content .account__help-content,
    #content.help {
      width: 94%;
    }
  }

  @media screen and (max-width: 767px) {
    #content.customer-support-centre,
    #content .account__help-content,
    #content.help {
      width: 94%;
    }
  }

  #content.customer-support-centre .customer-centre__nav-item a,
  #content .account__help-content .customer-centre__nav-item a,
  #content.help .customer-centre__nav-item a {
    text-decoration: none !important;
  }

  #content.customer-support-centre .customer-form,
  #content .account__help-content .customer-form,
  #content.help .customer-form {
    padding: 0 0 1.5em;
    margin: 0 auto;
  }

  #content.customer-support-centre .customer-form .form-title,
  #content .account__help-content .customer-form .form-title,
  #content.help .customer-form .form-title {
    text-align: center;
    padding: 0 1%;
  }

  #content.customer-support-centre .customer-form .form-title p,
  #content .account__help-content .customer-form .form-title p,
  #content.help .customer-form .form-title p {
    ${Body1Styles({ alignment: TextAlignment.INHERIT })};
    margin: 24px auto 24px !important;
    text-align: center;
  }

  #content.customer-support-centre .customer-form .errormessage,
  #content .account__help-content .customer-form .errormessage,
  #content.help .customer-form .errormessage {
    width: 100%;
    margin: 0 auto 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 10px 10px 10px 30px;
  }

  #content.customer-support-centre .customer-form .errormessage:before,
  #content .account__help-content .customer-form .errormessage:before,
  #content.help .customer-form .errormessage:before {
    content: url("//images.arcteryx.com/foundation-ui/forms/caution.svg");
    display: inline-block;
    width: 15px;
    float: left;
    margin-left: -20px;
  }

  #content.customer-support-centre .customer-form textarea,
  #content .account__help-content .customer-form textarea,
  #content.help .customer-form textarea {
    margin-bottom: 1.5em;
  }

  #content.customer-support-centre #loginform,
  #content .account__help-content #loginform,
  #content.help #loginform {
    margin: 3em 0;
    padding: 0;
  }

  #content.customer-support-centre #loginform .form-row.center-align,
  #content .account__help-content #loginform .form-row.center-align,
  #content.help #loginform .form-row.center-align {
    margin: 1em auto 0;
  }

  #content.customer-support-centre
    #loginform
    .form-row.center-align:last-of-type,
  #content
    .account__help-content
    #loginform
    .form-row.center-align:last-of-type,
  #content.help #loginform .form-row.center-align:last-of-type {
    margin: 0 auto;
  }

  #content.customer-support-centre .logIn,
  #content .account__help-content .logIn,
  #content.help .logIn {
    float: right;
    margin-top: -40px;
    font-size: 14px;
  }

  #content.customer-support-centre .logIn:before,
  #content .account__help-content .logIn:before,
  #content.help .logIn:before {
    content: url(//images.arcteryx.com/foundation-ui/svgs/User.svg);
    width: 20px;
    padding-right: 5px;
    display: inline-block;
    vertical-align: text-bottom;
  }

  @media screen and (max-width: 767px) {
    #content.customer-support-centre .logIn,
    #content .account__help-content .logIn,
    #content.help .logIn {
      display: none;
    }
  }

  #content.customer-support-centre h2,
  #content .account__help-content h2,
  #content.help h2 {
    ${H3Styles({ alignment: TextAlignment.INHERIT })};
  }

  #content.customer-support-centre h3,
  #content .account__help-content h3,
  #content.help h3 {
    text-transform: uppercase;
    font-size: 16px;
    line-height: 18px;
    font-family: "urw-din-condensed", arial, sans-serif;
    max-width: 750px;
  }

  #content.customer-support-centre p,
  #content .account__help-content p,
  #content.help p {
    line-height: 1.5em;
    max-width: 650px;
  }

  .HELP.SIZING #content.customer-support-centre p,
  .HELP.SIZING #content .account__help-content p,
  .HELP.SIZING #content.help p {
    max-width: 680px;
  }

  #content.customer-support-centre .accordion__toggle,
  #content .account__help-content .accordion__toggle,
  #content.help .accordion__toggle {
    top: 0;
    bottom: initial;
    padding-top: 17px;
  }

  #content.customer-support-centre .accordion__title p,
  #content .account__help-content .accordion__title p,
  #content.help .accordion__title p {
    max-width: none;
  }

  #content.customer-support-centre .FAQ dt,
  #content .account__help-content .FAQ dt,
  #content.help .FAQ dt {
    font-size: 18px;
    font-family: "urw-din-condensed", arial, sans-serif;
    line-height: 1.5em;
    max-width: 650px;
    margin: 0 0 1em 0;
    -webkit-transition: 0.2s ease all;
    transition: 0.2s ease all;
  }

  #content.customer-support-centre .FAQ dt.expand,
  #content .account__help-content .FAQ dt.expand,
  #content.help .FAQ dt.expand {
    font-size: 16px;
    font-family: var(--font-helvetica);
    background-image: url(//images.arcteryx.com/misc/expand.gif);
    background-repeat: no-repeat;
    background-position: right center;
    padding-right: 1em;
  }

  #content.customer-support-centre .accordion,
  #content .account__help-content .accordion,
  #content.help .accordion {
    margin-bottom: 0.5em;
    width: 100%;
  }

  #content.customer-support-centre .accordion__content ul,
  #content .account__help-content .accordion__content ul,
  #content.help .accordion__content ul {
    margin: 0 0 1.5em 0;
  }

  #content.customer-support-centre .accordion__content table,
  #content .account__help-content .accordion__content table,
  #content.help .accordion__content table {
    width: 95%;
    margin: 0 2% 1.5em;
    border-collapse: collapse;
  }

  #content.customer-support-centre .accordion__content table th,
  #content.customer-support-centre .accordion__content table td,
  #content .account__help-content .accordion__content table th,
  #content .account__help-content .accordion__content table td,
  #content.help .accordion__content table th,
  #content.help .accordion__content table td {
    padding: 10px;
    vertical-align: top;
    border: 1px solid black;
  }

  #content.customer-support-centre ol,
  #content .account__help-content ol,
  #content.help ol {
    list-style-type: decimal;
  }

  #content.customer-support-centre ol li,
  #content .account__help-content ol li,
  #content.help ol li {
    margin-left: 2em;
    max-width: 650px;
  }

  #content.customer-support-centre .breadcrumb,
  #content .account__help-content .breadcrumb,
  #content.help .breadcrumb {
    display: inline-block;
    margin: -1em auto 0;
  }

  #content.customer-support-centre .breadcrumb {
    margin: var(--space-green) auto;
  }

  #content.customer-support-centre
    .breadcrumb
    .breadcrumb__list-item
    .breadcrumb__list-item-link
    span {
    ${LinkStyles({
      variant: Variant.SMALL
    })};
    padding: 0 !important;
  }

  .breadcrumb .breadcrumb__list-item .breadcrumb__list-item-link:after,
  #content
    .breadcrumb
    .breadcrumb__list-item
    .breadcrumb__list-item-link:after {
    margin: 0 4px;
  }

  #content.customer-support-centre .breadcrumb h1,
  #content .account__help-content .breadcrumb h1,
  #content.help .breadcrumb h1 {
    margin: 0;
  }

  #content.customer-support-centre
    .breadcrumb
    .breadcrumb__list-item:last-of-type,
  #content
    .account__help-content
    .breadcrumb
    .breadcrumb__list-item:last-of-type,
  #content.help .breadcrumb .breadcrumb__list-item:last-of-type {
    display: block !important;
  }

  #content.customer-support-centre .customer-centre__wrapper,
  #content.customer-support-centre .help__wrapper,
  #content .account__help-content .customer-centre__wrapper,
  #content .account__help-content .help__wrapper,
  #content.help .customer-centre__wrapper,
  #content.help .help__wrapper {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }

  @media screen and (min-width: 930px) {
    #content.customer-support-centre .customer-centre__wrapper,
    #content.customer-support-centre .help__wrapper,
    #content .account__help-content .customer-centre__wrapper,
    #content .account__help-content .help__wrapper,
    #content.help .customer-centre__wrapper,
    #content.help .help__wrapper {
      -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
    }
  }

  #content.customer-support-centre .customer-centre__wrapper ul,
  #content.customer-support-centre .help__wrapper ul,
  #content .account__help-content .customer-centre__wrapper ul,
  #content .account__help-content .help__wrapper ul,
  #content.help .customer-centre__wrapper ul,
  #content.help .help__wrapper ul {
    padding-left: 2em;
  }

  #content.customer-support-centre .customer-centre__wrapper ul li,
  #content.customer-support-centre .help__wrapper ul li,
  #content .account__help-content .customer-centre__wrapper ul li,
  #content .account__help-content .help__wrapper ul li,
  #content.help .customer-centre__wrapper ul li,
  #content.help .help__wrapper ul li {
    font-size: 15px;
    max-width: 650px;
    line-height: 1.5em;
    list-style: disc;
  }

  #content.customer-support-centre .customer-centre__main,
  #content.customer-support-centre .help__main-panel,
  #content .account__help-content .customer-centre__main,
  #content .account__help-content .help__main-panel,
  #content.help .customer-centre__main,
  #content.help .help__main-panel {
    width: 99%;
    -webkit-box-ordinal-group: 2;
    -ms-flex-order: 1;
    order: 1;
  }

  @media screen and (min-width: 768px) {
    #content.customer-support-centre .customer-centre__main,
    #content.customer-support-centre .help__main-panel,
    #content .account__help-content .customer-centre__main,
    #content .account__help-content .help__main-panel,
    #content.help .customer-centre__main,
    #content.help .help__main-panel {
      width: 100%;
    }
  }

  @media screen and (min-width: 930px) {
    #content.customer-support-centre .customer-centre__main,
    #content.customer-support-centre .help__main-panel,
    #content .account__help-content .customer-centre__main,
    #content .account__help-content .help__main-panel,
    #content.help .customer-centre__main,
    #content.help .help__main-panel {
      margin-right: 2em;
    }
  }

  #content.customer-support-centre
    .customer-centre__main
    .customer-centre__main-inner,
  #content.customer-support-centre
    .help__main-panel
    .customer-centre__main-inner,
  #content
    .account__help-content
    .customer-centre__main
    .customer-centre__main-inner,
  #content
    .account__help-content
    .help__main-panel
    .customer-centre__main-inner,
  #content.help .customer-centre__main .customer-centre__main-inner,
  #content.help .help__main-panel .customer-centre__main-inner {
    width: 100%;
    max-width: 850px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin: 2em auto;
  }

  @media screen and (min-width: 870px) {
    #content.customer-support-centre
      .customer-centre__main
      .customer-centre__main-inner,
    #content.customer-support-centre
      .help__main-panel
      .customer-centre__main-inner,
    #content
      .account__help-content
      .customer-centre__main
      .customer-centre__main-inner,
    #content
      .account__help-content
      .help__main-panel
      .customer-centre__main-inner,
    #content.help .customer-centre__main .customer-centre__main-inner,
    #content.help .help__main-panel .customer-centre__main-inner {
      margin: 2em 0;
    }
  }

  .URBAN #content.customer-support-centre .customer-centre__nav-item a,
  .URBAN #content .account__help-content .customer-centre__nav-item a,
  .URBAN #content.help .customer-centre__nav-item a {
    width: 100%;
    padding: 30px 0 0 0;
  }

  @media screen and (min-width: 414px) {
    .URBAN #content.customer-support-centre .customer-centre__nav-item a,
    .URBAN #content .account__help-content .customer-centre__nav-item a,
    .URBAN #content.help .customer-centre__nav-item a {
      padding: 38px 0 0 0;
    }
  }

  @media screen and (min-width: 768px) {
    .URBAN #content.customer-support-centre .customer-centre__nav-item a,
    .URBAN #content .account__help-content .customer-centre__nav-item a,
    .URBAN #content.help .customer-centre__nav-item a {
      padding: 0;
      margin-left: -10px;
    }
  }

  .URBAN
    #content.customer-support-centre
    .customer-centre__nav-item.product-care
    a,
  .URBAN #content.customer-support-centre .customer-centre__nav-item.faq a,
  .URBAN
    #content
    .account__help-content
    .customer-centre__nav-item.product-care
    a,
  .URBAN #content .account__help-content .customer-centre__nav-item.faq a,
  .URBAN #content.help .customer-centre__nav-item.product-care a,
  .URBAN #content.help .customer-centre__nav-item.faq a {
    padding: 38px 0 0 0;
  }

  @media screen and (min-width: 768px) {
    .URBAN
      #content.customer-support-centre
      .customer-centre__nav-item.product-care
      a,
    .URBAN #content.customer-support-centre .customer-centre__nav-item.faq a,
    .URBAN
      #content
      .account__help-content
      .customer-centre__nav-item.product-care
      a,
    .URBAN #content .account__help-content .customer-centre__nav-item.faq a,
    .URBAN #content.help .customer-centre__nav-item.product-care a,
    .URBAN #content.help .customer-centre__nav-item.faq a {
      padding: 0;
    }
  }

  @media screen and (min-width: 360px) {
    .URBAN
      #content.customer-support-centre
      .customer-centre__nav-item.order-tracking
      a,
    .URBAN
      #content
      .account__help-content
      .customer-centre__nav-item.order-tracking
      a,
    .URBAN #content.help .customer-centre__nav-item.order-tracking a {
      padding: 38px 0 0 0;
    }
  }

  @media screen and (min-width: 768px) {
    .URBAN
      #content.customer-support-centre
      .customer-centre__nav-item.order-tracking
      a,
    .URBAN
      #content
      .account__help-content
      .customer-centre__nav-item.order-tracking
      a,
    .URBAN #content.help .customer-centre__nav-item.order-tracking a {
      padding: 0;
    }
  }

  #content.customer-support-centre .sizing-category-wrapper,
  #content .account__help-content .sizing-category-wrapper,
  #content.help .sizing-category-wrapper {
    display: inline-block;
    text-align: center;
    margin: 0 auto 2em;
  }

  @media screen and (max-width: 711px) {
    .NORWEGIAN #content.customer-support-centre .sizing-category-wrapper,
    .SPANISH #content.customer-support-centre .sizing-category-wrapper,
    .NORWEGIAN #content .account__help-content .sizing-category-wrapper,
    .SPANISH #content .account__help-content .sizing-category-wrapper,
    .NORWEGIAN #content.help .sizing-category-wrapper,
    .SPANISH #content.help .sizing-category-wrapper {
      margin: 0 auto 3em;
    }
  }

  @media screen and (min-width: 712px) {
    #content.customer-support-centre .sizing-category-wrapper,
    #content .account__help-content .sizing-category-wrapper,
    #content.help .sizing-category-wrapper {
      margin: 0 5% 2em;
    }
  }

  @media screen and (min-width: 930px) {
    #content.customer-support-centre .sizing-category-wrapper,
    #content .account__help-content .sizing-category-wrapper,
    #content.help .sizing-category-wrapper {
      margin: 0 1% 2em;
    }
    .NORWEGIAN #content.customer-support-centre .sizing-category-wrapper,
    .SPANISH #content.customer-support-centre .sizing-category-wrapper,
    .NORWEGIAN #content .account__help-content .sizing-category-wrapper,
    .SPANISH #content .account__help-content .sizing-category-wrapper,
    .NORWEGIAN #content.help .sizing-category-wrapper,
    .SPANISH #content.help .sizing-category-wrapper {
      margin: 0 auto 2em;
    }
  }

  @media screen and (min-width: 1187px) {
    #content.customer-support-centre .sizing-category-wrapper,
    #content .account__help-content .sizing-category-wrapper,
    #content.help .sizing-category-wrapper {
      margin: 0 5% 2em;
    }
    .NORWEGIAN #content.customer-support-centre .sizing-category-wrapper,
    .SPANISH #content.customer-support-centre .sizing-category-wrapper,
    .NORWEGIAN #content .account__help-content .sizing-category-wrapper,
    .SPANISH #content .account__help-content .sizing-category-wrapper,
    .NORWEGIAN #content.help .sizing-category-wrapper,
    .SPANISH #content.help .sizing-category-wrapper {
      margin: 0 3% 2em;
    }
  }

  @media screen and (min-width: 1400px) {
    #content.customer-support-centre .sizing-category-wrapper,
    #content .account__help-content .sizing-category-wrapper,
    #content.help .sizing-category-wrapper {
      margin: 0 6% 2em;
    }
    .NORWEGIAN #content.customer-support-centre .sizing-category-wrapper,
    .SPANISH #content.customer-support-centre .sizing-category-wrapper,
    .NORWEGIAN #content .account__help-content .sizing-category-wrapper,
    .SPANISH #content .account__help-content .sizing-category-wrapper,
    .NORWEGIAN #content.help .sizing-category-wrapper,
    .SPANISH #content.help .sizing-category-wrapper {
      margin: 0 4% 2em;
    }
  }

  @media screen and (min-width: 1500px) {
    #content.customer-support-centre .sizing-category-wrapper,
    #content .account__help-content .sizing-category-wrapper,
    #content.help .sizing-category-wrapper {
      margin: 0 8% 2em;
    }
    .NORWEGIAN #content.customer-support-centre .sizing-category-wrapper,
    .SPANISH #content.customer-support-centre .sizing-category-wrapper,
    .NORWEGIAN #content .account__help-content .sizing-category-wrapper,
    .SPANISH #content .account__help-content .sizing-category-wrapper,
    .NORWEGIAN #content.help .sizing-category-wrapper,
    .SPANISH #content.help .sizing-category-wrapper {
      margin: 0 6% 2em;
    }
  }

  #content.customer-support-centre .sizing-category-wrapper a,
  #content .account__help-content .sizing-category-wrapper a,
  #content.help .sizing-category-wrapper a {
    display: block;
    margin: 0 auto;
    text-transform: uppercase;
    min-width: 130px;
  }

  @media screen and (min-width: 414px) {
    #content.customer-support-centre .sizing-category-wrapper a,
    #content .account__help-content .sizing-category-wrapper a,
    #content.help .sizing-category-wrapper a {
      min-width: 170px;
    }
  }

  @media screen and (min-width: 414px) {
    #content.customer-support-centre .sizing-category-wrapper a,
    #content .account__help-content .sizing-category-wrapper a,
    #content.help .sizing-category-wrapper a {
      height: 215px;
    }
  }

  #content.customer-support-centre
    .sizing-category-wrapper
    .customer-centre__category-title,
  #content
    .account__help-content
    .sizing-category-wrapper
    .customer-centre__category-title,
  #content.help .sizing-category-wrapper .customer-centre__category-title {
    max-width: 180px;
    margin: 1em auto;
  }

  @media screen and (max-width: 539px) {
    #content.customer-support-centre .sizing-category-wrapper.backpack-harness,
    #content .account__help-content .sizing-category-wrapper.backpack-harness,
    #content.help .sizing-category-wrapper.backpack-harness {
      margin-left: 0;
    }
  }

  @media screen and (min-width: 414px) {
    #content.customer-support-centre .sizing-category-wrapper.mens,
    #content.customer-support-centre .sizing-category-wrapper.footwear,
    #content .account__help-content .sizing-category-wrapper.mens,
    #content .account__help-content .sizing-category-wrapper.footwear,
    #content.help .sizing-category-wrapper.mens,
    #content.help .sizing-category-wrapper.footwear {
      margin-left: 0;
    }
  }

  #content.customer-support-centre .sizing-category-wrapper.mens a,
  #content.customer-support-centre .sizing-category-wrapper.womens a,
  #content .account__help-content .sizing-category-wrapper.mens a,
  #content .account__help-content .sizing-category-wrapper.womens a,
  #content.help .sizing-category-wrapper.mens a,
  #content.help .sizing-category-wrapper.womens a {
    height: 340px;
  }

  @media screen and (min-width: 414px) {
    #content.customer-support-centre .sizing-category-wrapper.mens a,
    #content.customer-support-centre .sizing-category-wrapper.womens a,
    #content .account__help-content .sizing-category-wrapper.mens a,
    #content .account__help-content .sizing-category-wrapper.womens a,
    #content.help .sizing-category-wrapper.mens a,
    #content.help .sizing-category-wrapper.womens a {
      height: 440px;
    }
  }

  #content.customer-support-centre .sizing-category-wrapper.mens img,
  #content.customer-support-centre .sizing-category-wrapper.womens img,
  #content .account__help-content .sizing-category-wrapper.mens img,
  #content .account__help-content .sizing-category-wrapper.womens img,
  #content.help .sizing-category-wrapper.mens img,
  #content.help .sizing-category-wrapper.womens img {
    height: 250px;
  }

  @media screen and (min-width: 414px) {
    #content.customer-support-centre .sizing-category-wrapper.mens img,
    #content.customer-support-centre .sizing-category-wrapper.womens img,
    #content .account__help-content .sizing-category-wrapper.mens img,
    #content .account__help-content .sizing-category-wrapper.womens img,
    #content.help .sizing-category-wrapper.mens img,
    #content.help .sizing-category-wrapper.womens img {
      height: 350px;
    }
  }

  #content.customer-support-centre .sizing-category-wrapper.footwear,
  #content .account__help-content .sizing-category-wrapper.footwear,
  #content.help .sizing-category-wrapper.footwear {
    margin-top: 33px;
  }

  #content.customer-support-centre .sizing-category-wrapper.hat,
  #content .account__help-content .sizing-category-wrapper.hat,
  #content.help .sizing-category-wrapper.hat {
    width: 100%;
  }

  @media screen and (min-width: 545px) {
    #content.customer-support-centre .sizing-category-wrapper.hat,
    #content .account__help-content .sizing-category-wrapper.hat,
    #content.help .sizing-category-wrapper.hat {
      width: auto;
      margin-top: 44px;
    }
  }

  #content.customer-support-centre .sizing-category-wrapper .harness-desktop,
  #content .account__help-content .sizing-category-wrapper .harness-desktop,
  #content.help .sizing-category-wrapper .harness-desktop {
    display: none;
    margin-top: 45px;
  }

  @media screen and (min-width: 545px) {
    #content.customer-support-centre .sizing-category-wrapper .harness-desktop,
    #content .account__help-content .sizing-category-wrapper .harness-desktop,
    #content.help .sizing-category-wrapper .harness-desktop {
      display: block;
    }
  }

  #content.customer-support-centre .sizing-category-wrapper.harness-mobile,
  #content .account__help-content .sizing-category-wrapper.harness-mobile,
  #content.help .sizing-category-wrapper.harness-mobile {
    margin-top: 40px;
  }

  @media screen and (min-width: 545px) {
    #content.customer-support-centre .sizing-category-wrapper.harness-mobile,
    #content .account__help-content .sizing-category-wrapper.harness-mobile,
    #content.help .sizing-category-wrapper.harness-mobile {
      display: none;
    }
  }

  #content.customer-support-centre .customer-centre__category-title,
  #content .account__help-content .customer-centre__category-title,
  #content.help .customer-centre__category-title {
    display: block;
    font-family: "urw-din-condensed", arial, sans-serif;
    margin: 1em 0;
  }

  .URBAN.HELP.SIZING #content.customer-support-centre .units-toggle a,
  .URBAN.HELP.SIZING #content .account__help-content .units-toggle a,
  .URBAN.HELP.SIZING #content.help .units-toggle a {
    margin-right: -2px;
  }

  .URBAN.HELP.SIZING
    #content.customer-support-centre
    table
    tr:nth-child(odd)
    td,
  .URBAN.HELP.SIZING #content .account__help-content table tr:nth-child(odd) td,
  .URBAN.HELP.SIZING #content.help table tr:nth-child(odd) td {
    background: #fff;
    color: #000;
  }

  .URBAN.HELP.SIZING
    #content.customer-support-centre
    .find-your-measurements
    img,
  .URBAN.HELP.SIZING
    #content
    .account__help-content
    .find-your-measurements
    img,
  .URBAN.HELP.SIZING #content.help .find-your-measurements img {
    margin: 0 5px 0 0;
    width: 140px;
  }

  @media screen and (min-width: 930px) {
    .URBAN.HELP.SIZING
      #content.customer-support-centre
      .find-your-measurements
      img,
    .URBAN.HELP.SIZING
      #content
      .account__help-content
      .find-your-measurements
      img,
    .URBAN.HELP.SIZING #content.help .find-your-measurements img {
      margin: 0 25px 0 5%;
      width: auto;
    }
  }

  .URBAN.HELP.SIZING
    #content.customer-support-centre
    .find-your-measurements
    h3,
  .URBAN.HELP.SIZING #content .account__help-content .find-your-measurements h3,
  .URBAN.HELP.SIZING #content.help .find-your-measurements h3 {
    position: absolute;
    top: -40px;
    left: 0;
  }

  @media screen and (min-width: 930px) {
    .URBAN.HELP.SIZING
      #content.customer-support-centre
      .find-your-measurements
      h3,
    .URBAN.HELP.SIZING
      #content
      .account__help-content
      .find-your-measurements
      h3,
    .URBAN.HELP.SIZING #content.help .find-your-measurements h3 {
      position: relative;
      top: initial;
      left: initial;
      right: initial;
      margin-bottom: -20px;
      margin-top: 20px;
    }
  }

  .URBAN.HELP.SIZING #content.customer-support-centre .find-your-measurements p,
  .URBAN.HELP.SIZING #content .account__help-content .find-your-measurements p,
  .URBAN.HELP.SIZING #content.help .find-your-measurements p {
    max-width: none;
    margin: 0 5% 1.5em 0;
  }

  .URBAN.HELP.SIZING
    #content.customer-support-centre
    .find-your-measurements
    p:first-of-type,
  .URBAN.HELP.SIZING
    #content
    .account__help-content
    .find-your-measurements
    p:first-of-type,
  .URBAN.HELP.SIZING #content.help .find-your-measurements p:first-of-type {
    margin: 40px 0 10px 0;
  }

  @media screen and (min-width: 930px) {
    .URBAN.HELP.SIZING
      #content.customer-support-centre
      .find-your-measurements
      p:first-of-type,
    .URBAN.HELP.SIZING
      #content
      .account__help-content
      .find-your-measurements
      p:first-of-type,
    .URBAN.HELP.SIZING #content.help .find-your-measurements p:first-of-type {
      margin: 40px 5% 10px 0;
    }
  }

  .ARC-NAMING
    #content.customer-support-centre
    .customer-centre__wrapper-top.naming-scheme-banner,
  .ARC-NAMING
    #content
    .account__help-content
    .customer-centre__wrapper-top.naming-scheme-banner,
  .ARC-NAMING #content.help .customer-centre__wrapper-top.naming-scheme-banner {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-bottom: 0;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }

  @media screen and (min-width: 930px) {
    .ARC-NAMING
      #content.customer-support-centre
      .customer-centre__wrapper-top.naming-scheme-banner,
    .ARC-NAMING
      #content
      .account__help-content
      .customer-centre__wrapper-top.naming-scheme-banner,
    .ARC-NAMING
      #content.help
      .customer-centre__wrapper-top.naming-scheme-banner {
      -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
    }
  }

  .ARC-NAMING
    #content.customer-support-centre
    .customer-centre__wrapper-top.naming-scheme-banner
    h2,
  .ARC-NAMING
    #content
    .account__help-content
    .customer-centre__wrapper-top.naming-scheme-banner
    h2,
  .ARC-NAMING
    #content.help
    .customer-centre__wrapper-top.naming-scheme-banner
    h2 {
    margin: 0 0 10px 0;
  }

  @media screen and (min-width: 930px) {
    .ARC-NAMING #content.customer-support-centre .naming-scheme-banner div,
    .ARC-NAMING #content .account__help-content .naming-scheme-banner div,
    .ARC-NAMING #content.help .naming-scheme-banner div {
      width: 100%;
      margin: 0 0 0 2em;
    }
  }

  .ARC-NAMING #content.customer-support-centre .naming-scheme-banner img,
  .ARC-NAMING #content .account__help-content .naming-scheme-banner img,
  .ARC-NAMING #content.help .naming-scheme-banner img {
    width: 100%;
    margin: 0 0 2em 0;
  }

  @media screen and (min-width: 930px) {
    .ARC-NAMING #content.customer-support-centre .naming-scheme-banner img,
    .ARC-NAMING #content .account__help-content .naming-scheme-banner img,
    .ARC-NAMING #content.help .naming-scheme-banner img {
      width: 500px;
      margin: 0;
    }
  }

  @media screen and (min-width: 1280px) {
    .ARC-NAMING #content.customer-support-centre .naming-scheme-banner img,
    .ARC-NAMING #content .account__help-content .naming-scheme-banner img,
    .ARC-NAMING #content.help .naming-scheme-banner img {
      width: 600px;
    }
  }

  .ARC-NAMING #content.customer-support-centre .customer-centre__wrapper,
  .ARC-NAMING #content .account__help-content .customer-centre__wrapper,
  .ARC-NAMING #content.help .customer-centre__wrapper {
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }

  .ARC-NAMING
    #content.customer-support-centre
    .accordion:first-of-type
    .accordion__title,
  .ARC-NAMING
    #content
    .account__help-content
    .accordion:first-of-type
    .accordion__title,
  .ARC-NAMING #content.help .accordion:first-of-type .accordion__title {
    padding: 0;
  }

  .ARC-NAMING #content.customer-support-centre .accordion__title,
  .ARC-NAMING #content .account__help-content .accordion__title,
  .ARC-NAMING #content.help .accordion__title {
    cursor: default;
  }

  .ARC-NAMING #content.customer-support-centre .accordion__title p,
  .ARC-NAMING #content .account__help-content .accordion__title p,
  .ARC-NAMING #content.help .accordion__title p {
    font-family: var(--font-helvetica);
  }

  .ARC-NAMING #content.customer-support-centre .accordion__toggle,
  .ARC-NAMING #content .account__help-content .accordion__toggle,
  .ARC-NAMING #content.help .accordion__toggle {
    bottom: initial;
    top: 25px;
  }

  @media screen and (min-width: 769px) {
    .ARC-NAMING #content.customer-support-centre .accordion__toggle,
    .ARC-NAMING #content .account__help-content .accordion__toggle,
    .ARC-NAMING #content.help .accordion__toggle {
      display: none;
      bottom: 0;
    }
  }

  .ARC-NAMING
    #content.customer-support-centre
    .accordion--close
    .accordion__content,
  .ARC-NAMING
    #content
    .account__help-content
    .accordion--close
    .accordion__content,
  .ARC-NAMING #content.help .accordion--close .accordion__content {
    display: none;
  }

  .ARC-NAMING
    #content.customer-support-centre
    .accordion--open
    .accordion__content,
  .ARC-NAMING
    #content
    .account__help-content
    .accordion--open
    .accordion__content,
  .ARC-NAMING #content.help .accordion--open .accordion__content {
    margin: 1em 0 0 0;
  }

  @media screen and (min-width: 768px) {
    .ARC-NAMING
      #content.customer-support-centre
      .accordion--open
      .accordion__content,
    .ARC-NAMING
      #content
      .account__help-content
      .accordion--open
      .accordion__content,
    .ARC-NAMING #content.help .accordion--open .accordion__content {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
    }
  }

  .ARC-NAMING
    #content.customer-support-centre
    .accordion--open
    .accordion__content.help-arc-naming__product-family--primary,
  .ARC-NAMING
    #content
    .account__help-content
    .accordion--open
    .accordion__content.help-arc-naming__product-family--primary,
  .ARC-NAMING
    #content.help
    .accordion--open
    .accordion__content.help-arc-naming__product-family--primary {
    border-bottom: 1px solid #ccc;
    padding-bottom: 0;
  }

  @media screen and (min-width: 768px) {
    .ARC-NAMING
      #content.customer-support-centre
      .accordion--open
      .accordion__content.help-arc-naming__product-family--secondary,
    .ARC-NAMING
      #content
      .account__help-content
      .accordion--open
      .accordion__content.help-arc-naming__product-family--secondary,
    .ARC-NAMING
      #content.help
      .accordion--open
      .accordion__content.help-arc-naming__product-family--secondary {
      margin-top: 2em;
    }
  }

  .ARC-NAMING #content.customer-support-centre .naming-scheme-widget,
  .ARC-NAMING #content .account__help-content .naming-scheme-widget,
  .ARC-NAMING #content.help .naming-scheme-widget {
    width: 100%;
    margin: 0 0 1em 0;
  }

  @media screen and (min-width: 815px) {
    .ARC-NAMING #content.customer-support-centre .naming-scheme-widget,
    .ARC-NAMING #content .account__help-content .naming-scheme-widget,
    .ARC-NAMING #content.help .naming-scheme-widget {
      width: 34%;
      margin: 0 1em 2em 0;
    }
    .ARC-NAMING
      #content.customer-support-centre
      .naming-scheme-widget:nth-of-type(even),
    .ARC-NAMING
      #content
      .account__help-content
      .naming-scheme-widget:nth-of-type(even),
    .ARC-NAMING #content.help .naming-scheme-widget:nth-of-type(even) {
      margin: 0 1em 2em;
    }
  }

  @media screen and (min-width: 915px) {
    .ARC-NAMING #content.customer-support-centre .naming-scheme-widget,
    .ARC-NAMING #content .account__help-content .naming-scheme-widget,
    .ARC-NAMING #content.help .naming-scheme-widget {
      width: 36%;
      margin: 0 1em 2em 0;
    }
    .ARC-NAMING
      #content.customer-support-centre
      .naming-scheme-widget:nth-of-type(even),
    .ARC-NAMING
      #content
      .account__help-content
      .naming-scheme-widget:nth-of-type(even),
    .ARC-NAMING #content.help .naming-scheme-widget:nth-of-type(even) {
      margin: 0 1em 2em;
    }
  }

  @media screen and (min-width: 1280px) {
    .ARC-NAMING #content.customer-support-centre .naming-scheme-widget,
    .ARC-NAMING #content .account__help-content .naming-scheme-widget,
    .ARC-NAMING #content.help .naming-scheme-widget {
      width: 22%;
      margin: 0 0 2em;
    }
    .ARC-NAMING
      #content.customer-support-centre
      .naming-scheme-widget:nth-of-type(even),
    .ARC-NAMING
      #content
      .account__help-content
      .naming-scheme-widget:nth-of-type(even),
    .ARC-NAMING #content.help .naming-scheme-widget:nth-of-type(even) {
      margin: initial;
    }
    .ARC-NAMING
      #content.customer-support-centre
      .naming-scheme-widget:nth-of-type(2),
    .ARC-NAMING
      #content.customer-support-centre
      .naming-scheme-widget:nth-of-type(5),
    .ARC-NAMING
      #content.customer-support-centre
      .naming-scheme-widget:nth-of-type(8),
    .ARC-NAMING
      #content.customer-support-centre
      .naming-scheme-widget:nth-of-type(11),
    .ARC-NAMING
      #content.customer-support-centre
      .naming-scheme-widget:nth-of-type(14),
    .ARC-NAMING
      #content
      .account__help-content
      .naming-scheme-widget:nth-of-type(2),
    .ARC-NAMING
      #content
      .account__help-content
      .naming-scheme-widget:nth-of-type(5),
    .ARC-NAMING
      #content
      .account__help-content
      .naming-scheme-widget:nth-of-type(8),
    .ARC-NAMING
      #content
      .account__help-content
      .naming-scheme-widget:nth-of-type(11),
    .ARC-NAMING
      #content
      .account__help-content
      .naming-scheme-widget:nth-of-type(14),
    .ARC-NAMING #content.help .naming-scheme-widget:nth-of-type(2),
    .ARC-NAMING #content.help .naming-scheme-widget:nth-of-type(5),
    .ARC-NAMING #content.help .naming-scheme-widget:nth-of-type(8),
    .ARC-NAMING #content.help .naming-scheme-widget:nth-of-type(11),
    .ARC-NAMING #content.help .naming-scheme-widget:nth-of-type(14) {
      margin: 0 2em 2em;
    }
  }

  @media screen and (min-width: 1420px) {
    .ARC-NAMING #content.customer-support-centre .naming-scheme-widget,
    .ARC-NAMING #content .account__help-content .naming-scheme-widget,
    .ARC-NAMING #content.help .naming-scheme-widget {
      width: 24%;
      margin: 0 0 2em;
    }
    .ARC-NAMING
      #content.customer-support-centre
      .naming-scheme-widget:nth-of-type(even),
    .ARC-NAMING
      #content
      .account__help-content
      .naming-scheme-widget:nth-of-type(even),
    .ARC-NAMING #content.help .naming-scheme-widget:nth-of-type(even) {
      margin: initial;
    }
    .ARC-NAMING
      #content.customer-support-centre
      .naming-scheme-widget:nth-of-type(2),
    .ARC-NAMING
      #content.customer-support-centre
      .naming-scheme-widget:nth-of-type(5),
    .ARC-NAMING
      #content.customer-support-centre
      .naming-scheme-widget:nth-of-type(8),
    .ARC-NAMING
      #content.customer-support-centre
      .naming-scheme-widget:nth-of-type(11),
    .ARC-NAMING
      #content.customer-support-centre
      .naming-scheme-widget:nth-of-type(14),
    .ARC-NAMING
      #content
      .account__help-content
      .naming-scheme-widget:nth-of-type(2),
    .ARC-NAMING
      #content
      .account__help-content
      .naming-scheme-widget:nth-of-type(5),
    .ARC-NAMING
      #content
      .account__help-content
      .naming-scheme-widget:nth-of-type(8),
    .ARC-NAMING
      #content
      .account__help-content
      .naming-scheme-widget:nth-of-type(11),
    .ARC-NAMING
      #content
      .account__help-content
      .naming-scheme-widget:nth-of-type(14),
    .ARC-NAMING #content.help .naming-scheme-widget:nth-of-type(2),
    .ARC-NAMING #content.help .naming-scheme-widget:nth-of-type(5),
    .ARC-NAMING #content.help .naming-scheme-widget:nth-of-type(8),
    .ARC-NAMING #content.help .naming-scheme-widget:nth-of-type(11),
    .ARC-NAMING #content.help .naming-scheme-widget:nth-of-type(14) {
      margin: 0 2em 2em;
    }
  }

  .ARC-NAMING #content.customer-support-centre .naming-scheme-widget img,
  .ARC-NAMING #content .account__help-content .naming-scheme-widget img,
  .ARC-NAMING #content.help .naming-scheme-widget img {
    padding: 5px;
    border: 1px solid #ccc;
    width: 45px;
    margin-top: 0;
  }

  .ARC-NAMING
    #content.customer-support-centre
    .naming-scheme-widget__description,
  .ARC-NAMING
    #content
    .account__help-content
    .naming-scheme-widget__description,
  .ARC-NAMING #content.help .naming-scheme-widget__description {
    margin-left: -1em;
    width: 70%;
  }

  @media screen and (min-width: 360px) {
    .ARC-NAMING
      #content.customer-support-centre
      .naming-scheme-widget__description,
    .ARC-NAMING
      #content
      .account__help-content
      .naming-scheme-widget__description,
    .ARC-NAMING #content.help .naming-scheme-widget__description {
      width: 75%;
    }
  }

  @media screen and (min-width: 768px) {
    .ARC-NAMING
      #content.customer-support-centre
      .naming-scheme-widget__description,
    .ARC-NAMING
      #content
      .account__help-content
      .naming-scheme-widget__description,
    .ARC-NAMING #content.help .naming-scheme-widget__description {
      width: 100%;
    }
  }

  #content.customer-support-centre .customer-centre__video-wrapper,
  #content .account__help-content .customer-centre__video-wrapper,
  #content.help .customer-centre__video-wrapper {
    text-align: center;
  }

  #content.customer-support-centre .customer-centre__video,
  #content .account__help-content .customer-centre__video,
  #content.help .customer-centre__video {
    display: inline-block;
    position: relative;
    width: 100%;
    margin: 1em auto;
    text-align: center;
  }

  @media screen and (min-width: 360px) {
    #content.customer-support-centre .customer-centre__video,
    #content .account__help-content .customer-centre__video,
    #content.help .customer-centre__video {
      width: 340px;
      margin: 1em 1%;
    }
  }

  @media screen and (min-width: 930px) {
    #content.customer-support-centre .customer-centre__video,
    #content .account__help-content .customer-centre__video,
    #content.help .customer-centre__video {
      margin: 1em 2%;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 869px) {
    #content.customer-support-centre .customer-centre__video,
    #content .account__help-content .customer-centre__video,
    #content.help .customer-centre__video {
      width: 290px;
      margin: 1em 1%;
    }
  }

  @media screen and (min-width: 1187px) {
    #content.customer-support-centre .customer-centre__video,
    #content .account__help-content .customer-centre__video,
    #content.help .customer-centre__video {
      width: 410px;
    }
  }

  @media screen and (min-width: 1280px) {
    #content.customer-support-centre .customer-centre__video,
    #content .account__help-content .customer-centre__video,
    #content.help .customer-centre__video {
      margin: 1em 3%;
    }
  }

  @media screen and (min-width: 1480px) {
    #content.customer-support-centre .customer-centre__video,
    #content .account__help-content .customer-centre__video,
    #content.help .customer-centre__video {
      margin: 1em 5%;
    }
  }

  @media screen and (min-width: 1540px) {
    #content.customer-support-centre .customer-centre__video,
    #content .account__help-content .customer-centre__video,
    #content.help .customer-centre__video {
      width: 510px;
      margin: 1em 3%;
    }
  }

  #content.customer-support-centre .customer-centre__video .playBtn,
  #content .account__help-content .customer-centre__video .playBtn,
  #content.help .customer-centre__video .playBtn {
    position: absolute;
    bottom: 85px;
    left: 112px;
    z-index: 1;
    cursor: pointer;
  }

  @media screen and (min-width: 360px) {
    #content.customer-support-centre .customer-centre__video .playBtn,
    #content .account__help-content .customer-centre__video .playBtn,
    #content.help .customer-centre__video .playBtn {
      bottom: 103px;
      left: 137px;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 869px) {
    #content.customer-support-centre .customer-centre__video .playBtn,
    #content .account__help-content .customer-centre__video .playBtn,
    #content.help .customer-centre__video .playBtn {
      bottom: 85px;
      left: 112px;
    }
  }

  @media screen and (min-width: 1187px) {
    #content.customer-support-centre .customer-centre__video .playBtn,
    #content .account__help-content .customer-centre__video .playBtn,
    #content.help .customer-centre__video .playBtn {
      bottom: 121px;
      left: 172px;
    }
  }

  @media screen and (min-width: 1540px) {
    #content.customer-support-centre .customer-centre__video .playBtn,
    #content .account__help-content .customer-centre__video .playBtn,
    #content.help .customer-centre__video .playBtn {
      bottom: 151px;
      left: 222px;
    }
  }

  #content.customer-support-centre .customer-centre__video img,
  #content .account__help-content .customer-centre__video img,
  #content.help .customer-centre__video img {
    display: block;
    margin: auto;
    cursor: pointer;
    width: 290px;
    height: 174px;
  }

  @media screen and (min-width: 360px) {
    #content.customer-support-centre .customer-centre__video img,
    #content .account__help-content .customer-centre__video img,
    #content.help .customer-centre__video img {
      width: 340px;
      height: 210px;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 869px) {
    #content.customer-support-centre .customer-centre__video img,
    #content .account__help-content .customer-centre__video img,
    #content.help .customer-centre__video img {
      width: 290px;
      height: 174px;
    }
  }

  @media screen and (min-width: 1187px) {
    #content.customer-support-centre .customer-centre__video img,
    #content .account__help-content .customer-centre__video img,
    #content.help .customer-centre__video img {
      width: 410px;
      height: 246px;
    }
  }

  @media screen and (min-width: 1540px) {
    #content.customer-support-centre .customer-centre__video img,
    #content .account__help-content .customer-centre__video img,
    #content.help .customer-centre__video img {
      width: 510px;
      height: 306px;
    }
  }

  #content.customer-support-centre .customer-centre__video p,
  #content .account__help-content .customer-centre__video p,
  #content.help .customer-centre__video p {
    width: 320px;
    text-align: left;
    margin: 1em 0;
  }

  #content.customer-support-centre .customer-centre__panel,
  #content.customer-support-centre .help__side-panel,
  #content .account__help-content .customer-centre__panel,
  #content .account__help-content .help__side-panel,
  #content.help .customer-centre__panel,
  #content.help .help__side-panel {
    width: 100%;
    position: relative;
    padding: 25px 20px 0 0px;
    margin: 0 0 2em 0;
    -webkit-box-ordinal-group: 3;
    -ms-flex-order: 2;
    order: 2;
  }

  @media screen and (min-width: 930px) {
    #content.customer-support-centre .customer-centre__panel,
    #content.customer-support-centre .help__side-panel,
    #content .account__help-content .customer-centre__panel,
    #content .account__help-content .help__side-panel,
    #content.help .customer-centre__panel,
    #content.help .help__side-panel {
      width: 40%;
      border-top: 0;
      padding: 0 0 0 70px;
      border-left: 1px solid #ccc;
    }
  }

  #content.customer-support-centre .customer-centre__panel p,
  #content.customer-support-centre .help__side-panel p,
  #content .account__help-content .customer-centre__panel p,
  #content .account__help-content .help__side-panel p,
  #content.help .customer-centre__panel p,
  #content.help .help__side-panel p {
    margin: 0;
  }

  #content.customer-support-centre .customer-centre__panel strong,
  #content.customer-support-centre .help__side-panel strong,
  #content .account__help-content .customer-centre__panel strong,
  #content .account__help-content .help__side-panel strong,
  #content.help .customer-centre__panel strong,
  #content.help .help__side-panel strong {
    margin: 1em 0;
    display: inline-block;
    font-weight: normal;
    font-size: 15px;
    line-height: 1.5em;
  }

  #content.customer-support-centre
    .customer-centre__panel
    .customer-service-hours,
  #content.customer-support-centre .help__side-panel .customer-service-hours,
  #content
    .account__help-content
    .customer-centre__panel
    .customer-service-hours,
  #content .account__help-content .help__side-panel .customer-service-hours,
  #content.help .customer-centre__panel .customer-service-hours,
  #content.help .help__side-panel .customer-service-hours {
    font-family: var(--font-helvetica);
  }

  #content.customer-support-centre
    .customer-centre__panel
    .help__icon-tooltip:after,
  #content.customer-support-centre .help__side-panel .help__icon-tooltip:after,
  #content
    .account__help-content
    .customer-centre__panel
    .help__icon-tooltip:after,
  #content .account__help-content .help__side-panel .help__icon-tooltip:after,
  #content.help .customer-centre__panel .help__icon-tooltip:after,
  #content.help .help__side-panel .help__icon-tooltip:after {
    display: none;
  }

  @media screen and (min-width: 930px) {
    #content.customer-support-centre
      .customer-centre__panel
      .help__icon-tooltip:after,
    #content.customer-support-centre
      .help__side-panel
      .help__icon-tooltip:after,
    #content
      .account__help-content
      .customer-centre__panel
      .help__icon-tooltip:after,
    #content .account__help-content .help__side-panel .help__icon-tooltip:after,
    #content.help .customer-centre__panel .help__icon-tooltip:after,
    #content.help .help__side-panel .help__icon-tooltip:after {
      content: url(//images.arcteryx.com/foundation-ui/svgs/Question_Icon.svg);
      position: absolute;
      left: -45px;
      top: 2px;
      width: 30px;
      height: 30px;
      display: block;
    }
  }

  #content.customer-support-centre
    .customer-centre__info-panel__icon-tooltip:after,
  #content.customer-support-centre .help__icon-tooltip:after,
  #content
    .account__help-content
    .customer-centre__info-panel__icon-tooltip:after,
  #content .account__help-content .help__icon-tooltip:after,
  #content.help .customer-centre__info-panel__icon-tooltip:after,
  #content.help .help__icon-tooltip:after {
    content: url("//images.arcteryx.com/foundation-ui/svgs/Question_Icon.svg");
    position: absolute;
    left: 25px;
    top: 0;
    width: 30px;
    height: 30px;
    display: block;
  }

  @media screen and (max-width: 767px) {
    #content.customer-support-centre
      .customer-centre__info-panel__icon-tooltip:after,
    #content.customer-support-centre .help__icon-tooltip:after,
    #content
      .account__help-content
      .customer-centre__info-panel__icon-tooltip:after,
    #content .account__help-content .help__icon-tooltip:after,
    #content.help .customer-centre__info-panel__icon-tooltip:after,
    #content.help .help__icon-tooltip:after {
      left: 15px;
      top: 20px;
    }
  }

  #content.customer-support-centre .customer-centre__wrapper-top,
  #content .account__help-content .customer-centre__wrapper-top,
  #content.help .customer-centre__wrapper-top {
    border-bottom: 1px solid #ccc;
    margin: 0 0 2em;
  }

  #content.customer-support-centre .customer-centre__wrapper-top ul,
  #content .account__help-content .customer-centre__wrapper-top ul,
  #content.help .customer-centre__wrapper-top ul {
    padding-left: 2em;
  }

  #content.customer-support-centre .customer-centre__wrapper-top ul li,
  #content .account__help-content .customer-centre__wrapper-top ul li,
  #content.help .customer-centre__wrapper-top ul li {
    max-width: 650px;
    list-style-type: disc;
    font-size: 15px;
    line-height: 1.5em;
    margin: 0 0 1.5em 0;
  }

  .OUTDOORRETURNS
    #content.customer-support-centre
    .customer-centre__wrapper-top,
  .ORDERSTATUS #content.customer-support-centre .customer-centre__wrapper-top,
  .OUTDOORRETURNS #content .account__help-content .customer-centre__wrapper-top,
  .ORDERSTATUS #content .account__help-content .customer-centre__wrapper-top,
  .OUTDOORRETURNS #content.help .customer-centre__wrapper-top,
  .ORDERSTATUS #content.help .customer-centre__wrapper-top {
    margin: 2em 0;
  }

  #content.customer-support-centre .customer-centre__wrapper-bottom,
  #content .account__help-content .customer-centre__wrapper-bottom,
  #content.help .customer-centre__wrapper-bottom {
    width: 100%;
    text-align: center;
    margin: 2em auto 0;
  }

  @media screen and (min-width: 768px) {
    #content.customer-support-centre .customer-centre__wrapper-bottom,
    #content .account__help-content .customer-centre__wrapper-bottom,
    #content.help .customer-centre__wrapper-bottom {
      margin: 8em auto 0;
    }
  }

  #content.customer-support-centre .customer-centre__wrapper-bottom a,
  #content .account__help-content .customer-centre__wrapper-bottom a,
  #content.help .customer-centre__wrapper-bottom a {
    margin: 0;
    font-size: 15px;
    line-height: 1.5em;
    text-decoration: underline !important;
  }

  #content.customer-support-centre .customer-centre__wrapper-bottom a:after,
  #content .account__help-content .customer-centre__wrapper-bottom a:after,
  #content.help .customer-centre__wrapper-bottom a:after {
    content: "|";
    margin: 0 5px;
    text-decoration: none !important;
  }

  #content.customer-support-centre
    .customer-centre__wrapper-bottom
    a:last-of-type:after,
  #content
    .account__help-content
    .customer-centre__wrapper-bottom
    a:last-of-type:after,
  #content.help .customer-centre__wrapper-bottom a:last-of-type:after {
    content: "";
    margin: 0;
  }

  .PRODUCT-SERVICE.SPANISH .standard__cta-button {
    height: 54px;
  }

  .PRODUCT-SERVICE.NORWEGIAN .standard__cta-button {
    max-width: 440px;
  }

  .customer-centre__nav {
    width: 100%;
    -webkit-column-count: 2;
    -moz-column-count: 2;
    column-count: 2;
    -webkit-column-gap: 1em;
    -moz-column-gap: 1em;
    column-gap: 1em;
    margin: 1em 0 0 0;
  }

  @media screen and (min-width: 930px) {
    .customer-centre__nav {
      width: auto;
      -webkit-column-gap: 3em;
      -moz-column-gap: 3em;
      column-gap: 3em;
      margin-right: 1em;
    }
  }

  .customer-centre__nav-item,
  #search-results-no-results .customer-centre__nav-item {
    display: inline-block;
    font-family: var(--font-helvetica);
    width: 95%;
    height: 100px;
    padding: 2%;
    border: 1px solid #ccc;
    text-align: center;
    margin-bottom: 1em;
    position: relative;
    vertical-align: middle;
  }

  @media screen and (min-width: 768px) {
    .customer-centre__nav-item,
    #search-results-no-results .customer-centre__nav-item {
      height: 85px;
      margin-bottom: 2em;
    }
  }

  .customer-centre__nav-item.pro-faq,
  #search-results-no-results .customer-centre__nav-item.pro-faq {
    display: none !important;
  }

  .customer-centre__nav-item a,
  #search-results-no-results .customer-centre__nav-item a {
    display: inline-block;
    font-family: var(--font-helvetica) !important;
    text-transform: uppercase;
    padding: 10% 0 0 0;
    text-decoration: none !important;
    color: #000;
    font-family: var(--font-helvetica) !important;
  }

  @media screen and (min-width: 768px) {
    .customer-centre__nav-item a,
    #search-results-no-results .customer-centre__nav-item a {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      position: absolute;
      padding: 0;
      top: 50%;
      bottom: 50%;
      width: 100%;
    }
    .customer-centre__nav-item a > span,
    #search-results-no-results .customer-centre__nav-item a > span {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      margin: 0 auto;
    }
    .URBAN .customer-centre__nav-item a > span,
    .URBAN #search-results-no-results .customer-centre__nav-item a > span {
      display: inline-block;
    }
    .URBAN .customer-centre__nav-item a > span:hover,
    .URBAN .customer-centre__nav-item a > span:active,
    .URBAN #search-results-no-results .customer-centre__nav-item a > span:hover,
    .URBAN
      #search-results-no-results
      .customer-centre__nav-item
      a
      > span:active {
      text-decoration: underline !important;
    }
  }

  .customer-centre__nav-item a:hover > span > span,
  .customer-centre__nav-item a:active > span > span,
  #search-results-no-results .customer-centre__nav-item a:hover > span > span,
  #search-results-no-results .customer-centre__nav-item a:active > span > span {
    text-decoration: underline !important;
  }

  .customer-centre__nav-item a.icon__order-tracking,
  #search-results-no-results .customer-centre__nav-item a.icon__order-tracking {
    padding: 3% 0;
  }

  @media screen and (min-width: 930px) {
    .customer-centre__nav-item a.icon__order-tracking,
    #search-results-no-results
      .customer-centre__nav-item
      a.icon__order-tracking {
      padding: 4% 0;
    }
  }

  @media screen and (min-width: 768px) {
    .customer-service-centre__icon {
      max-height: 33px;
    }
  }

  .customer-service-centre__icon:before {
    width: 100%;
    font-size: 33px;
    margin: 0 0 10px 0;
  }

  @media screen and (min-width: 768px) {
    .customer-service-centre__icon:before {
      width: auto;
      margin: 0 10px 0 0;
    }
  }

  .icon__sizing-fit-guide:before {
    content: url("//images.arcteryx.com/foundation-ui/svgs/Ruler.svg");
    width: 30px;
    display: inline-block;
  }

  @media screen and (max-width: 767px) {
    .icon__sizing-fit-guide:before {
      display: block;
      margin: 0 auto 5px auto;
    }
  }

  .icon__product-service:before {
    content: url("//images.arcteryx.com/foundation-ui/svgs/ProductService.svg");
    width: 30px;
    display: inline-block;
  }

  @media screen and (max-width: 767px) {
    .icon__product-service:before {
      display: block;
      margin: 0 auto 5px auto;
    }
  }

  .icon__product-care:before {
    content: url("//images.arcteryx.com/foundation-ui/svgs/ProductCare.svg");
    width: 30px;
    display: inline-block;
  }

  @media screen and (max-width: 767px) {
    .icon__product-care:before {
      display: block;
      margin: 0 auto 5px auto;
    }
  }

  .icon__pro-faq:before {
    content: url("//images.arcteryx.com/foundation-ui/svgs/Pro.svg");
    display: block;
    height: 33px;
    -webkit-transform: scale(1);
    transform: scale(1);
    width: 27px;
  }

  @media screen and (max-width: 767px) {
    .icon__pro-faq:before {
      margin: 0 auto 10px auto;
    }
  }

  .icon__product-manuals:before {
    content: url("//images.arcteryx.com/foundation-ui/svgs/TechnicalManuals.svg");
    display: block;
    height: 33px;
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  @media screen and (min-width: 768px) {
    .icon__product-manuals:before {
      display: inline-block;
    }
  }

  .icon__download:before {
    content: url(https://images.arcteryx.com/misc/icon-download.svg);
    display: inline-block;
    -webkit-transform: scale(0.7);
    transform: scale(0.7);
    vertical-align: middle;
  }

  .icon__returns-and-refunds:before {
    content: url("//images.arcteryx.com/foundation-ui/svgs/ProductReturns.svg");
    width: 40px;
    display: inline-block;
  }

  @media screen and (max-width: 767px) {
    .icon__returns-and-refunds:before {
      display: block;
      margin: 0 auto 5px auto;
    }
  }

  .icon__shipping-and-delivery:before {
    content: url("//images.arcteryx.com/foundation-ui/svgs/ShippingDelivery.svg");
    width: 40px;
    display: inline-block;
  }

  @media screen and (max-width: 767px) {
    .icon__shipping-and-delivery:before {
      display: block;
      margin: 0 auto 5px auto;
    }
  }

  .icon__order-tracking:before {
    content: url("//images.arcteryx.com/foundation-ui/svgs/OrderTracking.svg");
    width: 30px;
    display: inline-block;
  }

  @media screen and (max-width: 767px) {
    .icon__order-tracking:before {
      display: block;
      margin: 0 auto 5px auto;
    }
  }

  .icon__naming-scheme:before {
    content: url("//images.arcteryx.com/foundation-ui/svgs/AlphaSV.svg");
    width: 25px;
    display: inline-block;
  }

  @media screen and (max-width: 767px) {
    .icon__naming-scheme:before {
      display: block;
      margin: 0 auto 5px auto;
    }
  }

  .icon__glossary:before {
    content: url("//images.arcteryx.com/foundation-ui/svgs/Glossary.svg");
    width: 30px;
    display: inline-block;
  }

  @media screen and (max-width: 767px) {
    .icon__glossary:before {
      display: block;
      margin: 0 auto 5px auto;
    }
  }

  .icon__faq:before {
    content: url("//images.arcteryx.com/foundation-ui/svgs/FAQ.svg");
    width: 30px;
    display: inline-block;
  }

  @media screen and (max-width: 767px) {
    .icon__faq:before {
      display: block;
      margin: 0 auto 5px auto;
    }
  }

  .icon__email:before {
    content: url("//images.arcteryx.com/foundation-ui/svgs/Email.svg");
    width: 30px;
    display: inline-block;
  }

  @media screen and (max-width: 767px) {
    .icon__email:before {
      display: block;
      margin: 0 auto 5px auto;
    }
  }

  .icon__counterfeit:before {
    content: url("//images.arcteryx.com/foundation-ui/svgs/Counterfeit.svg");
    width: 30px;
    display: inline-block;
  }

  @media screen and (max-width: 767px) {
    .icon__counterfeit:before {
      display: block;
      margin: 0 auto 5px auto;
    }
  }

  .icon__customer-service-centre:before {
    content: url("//images.arcteryx.com/foundation-ui/svgs/CustomerServiceCenter.svg");
    width: 30px;
    display: inline-block;
  }

  @media screen and (max-width: 767px) {
    .icon__customer-service-centre:before {
      display: block;
      margin: 0 auto 5px auto;
    }
  }

  .customer-centre__nav-item.glossary {
    display: none;
  }

  .JP.FAQ .customer-centre__panel,
  .JP.FAQ .help__side-panel {
    display: none;
  }

  .JP.FAQ #content #minorContent a {
    text-decoration: none;
  }

  .JP.FAQ #content #minorContent a:hover {
    text-decoration: underline !important;
  }

  .JP.FAQ #content #minorContent .silo {
    padding: 0;
  }

  .JP.FAQ #content #minorContent ul {
    padding-left: 0;
  }

  .JP.FAQ #content #minorContent li {
    list-style: none;
  }

  .JP.FAQ #content #mainContent {
    float: left;
    width: 98%;
  }

  @media screen and (min-width: 930px) {
    .JP.FAQ #content #mainContent {
      width: 62%;
      padding-left: 2em;
      border-left: 1px solid #ccc;
    }
  }

  .CN .customer-centre__nav-item.shipping,
  .CN .customer-centre__nav-item.order-tracking,
  .CN .customer-centre__nav-item.returns,
  .CN .customer-centre__nav-item.product-service {
    display: none;
  }

  .LEAF.CONTACT #minorContent {
    margin-top: 1em;
  }

  @media screen and (min-width: 768px) {
    .LEAF.CONTACT #minorContent {
      float: left;
      width: 35%;
      margin-top: 2em;
    }
  }

  @media screen and (min-width: 768px) {
    .LEAF.CONTACT #mainContent {
      float: left;
      width: 65%;
    }
  }

  @media screen and (min-width: 930px) {
    .LEAF.CONTACT #mainContent {
      width: 42%;
    }
  }

  /*# sourceMappingURL=help.css.map */
`;
